"use client";

import styles from "@/styles/home/category-grid.module.scss";
import Image from "next/image";

interface CategoryItem {
  title: string;
  href: string;
  image: string;
}

export default function CategoryGrid() {
  const categoryList: CategoryItem[] = [
    {
      title: "Appliances",
      href: "/appliances/",
      image: `${process.env.IMAGE_DOMAIN}/home/categories-menu/Appliances.svg`,
    },
    {
      title: "Furniture",
      href: "/furniture/",
      image: `${process.env.IMAGE_DOMAIN}/home/categories-menu/Furniture.svg`,
    },
    {
      title: "Baby, Kids & Toys",
      href: "/baby-kids-toys/",
      image: `${process.env.IMAGE_DOMAIN}/home/categories-menu/Baby.svg`,
    },
    {
      title: "Home & Garden",
      href: "/home-garden/",
      image: `${process.env.IMAGE_DOMAIN}/home/categories-menu/Home.svg`,
    },
    {
      title: "Pet Supplies",
      href: "/pet-supplies/",
      image: `${process.env.IMAGE_DOMAIN}/home/categories-menu/Pet.svg`,
    },
    {
      title: "Sports & Fitness",
      href: "/sports-fitness/",
      image: `${process.env.IMAGE_DOMAIN}/home/categories-menu/Sports.svg`,
    },
    {
      title: "Outdoor & Leisure",
      href: "/outdoor-leisure/",
      image: `${process.env.IMAGE_DOMAIN}/home/categories-menu/Outdoor.svg`,
    },
    {
      title: "Tools & Auto",
      href: "/tools-auto/",
      image: `${process.env.IMAGE_DOMAIN}/home/categories-menu/Tools.svg`,
    },
    {
      title: "Bedding & Bath",
      href: "/bedding-bath/",
      image: `${process.env.IMAGE_DOMAIN}/home/categories-menu/Bedding.svg`,
    },
    {
      title: "Health & Beauty",
      href: "/health-beauty/",
      image: `${process.env.IMAGE_DOMAIN}/home/categories-menu/Health.svg`,
    },
    {
      title: "Electronics",
      href: "/electronics/",
      image: `${process.env.IMAGE_DOMAIN}/home/categories-menu/Electronics.svg`,
    },
    {
      title: "Novelties & Gifts",
      href: "/novelties-gifts/",
      image: `${process.env.IMAGE_DOMAIN}/home/categories-menu/Novelties.svg`,
    },
    {
      title: "Musical Instruments",
      href: "/musical-instruments/",
      image: `${process.env.IMAGE_DOMAIN}/home/categories-menu/Musical.svg`,
    },
    {
      title: "Jewellery",
      href: "/jewellery/",
      image: `${process.env.IMAGE_DOMAIN}/home/categories-menu/Jewellery.svg`,
    },
    {
      title: "LED Lights",
      href: "/led-lights/",
      image: `${process.env.IMAGE_DOMAIN}/home/categories-menu/LED.svg`,
    },
    {
      title: "Fashion & Bags",
      href: "/fashion-bags/",
      image: `${process.env.IMAGE_DOMAIN}/svg/category/icon-category-109.svg`,
    },
    {
      title: "Computers & IT",
      href: "/computers-it/",
      image: `${process.env.IMAGE_DOMAIN}/home/categories-menu/Computers.svg`,
    },
  ];
  const handleViewDetail = (cate: CategoryItem) => {
    if (!cate.href) return;
    window.location.href = `/category${cate.href}`;
  };

  return (
    <div className={styles["comp-category-grid"]}>
      <div className={styles["category-grid-list"]}>
        {categoryList.map((cate: CategoryItem, index: number) => (
          <div
            className={styles["category-grid-item"]}
            key={cate.title}
            onClick={() => handleViewDetail(cate)}
          >
            <Image
              className={styles["category-icon"]}
              src={cate.image}
              alt={cate.title}
              width={44}
              height={44}
              priority={index < 5 ? true : false}
            />

            <div className={styles["category-name"]}>{cate.title}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
